"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformJSONToFlowBoardNode = exports.transformFlowBoardNodeToJSON = void 0;

var _flowBoardScreenNode = require("./flow-board-screen-node");

var _flowBoardShapeNode = require("./flow-board-shape-node");

var _flowBoardTextNode = require("./flow-board-text-node");

var _flowBoardVariantGroupNode = require("./flow-board-variant-group-node");

/* tslint:disable */

/* eslint-disable */

/**
 * Zeplin API
 * Access your resources in Zeplin
 *
 * Contact: support@zeplin.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var transformJSONToFlowBoardNode = function transformJSONToFlowBoardNode(value) {
  switch (value.type) {
    case 'ScreenNode':
      return (0, _flowBoardScreenNode.transformJSONToFlowBoardScreenNode)(value);

    case 'ShapeNode':
      return (0, _flowBoardShapeNode.transformJSONToFlowBoardShapeNode)(value);

    case 'TextLabelNode':
      return (0, _flowBoardTextNode.transformJSONToFlowBoardTextNode)(value);

    case 'VariantGroupNode':
      return (0, _flowBoardVariantGroupNode.transformJSONToFlowBoardVariantGroupNode)(value);

    default:
      throw new Error("No variant of FlowBoardNode exists with 'type=".concat(value.type, "'"));
  }
};

exports.transformJSONToFlowBoardNode = transformJSONToFlowBoardNode;

var transformFlowBoardNodeToJSON = function transformFlowBoardNodeToJSON(value) {
  switch (value.type) {
    case 'ScreenNode':
      return (0, _flowBoardScreenNode.transformFlowBoardScreenNodeToJSON)(value);

    case 'ShapeNode':
      return (0, _flowBoardShapeNode.transformFlowBoardShapeNodeToJSON)(value);

    case 'TextLabelNode':
      return (0, _flowBoardTextNode.transformFlowBoardTextNodeToJSON)(value);

    case 'VariantGroupNode':
      return (0, _flowBoardVariantGroupNode.transformFlowBoardVariantGroupNodeToJSON)(value);
  }
};
/**
 * @type FlowBoardNode
 * @export
 */


exports.transformFlowBoardNodeToJSON = transformFlowBoardNodeToJSON;